import { trackOpenAILead } from "@/lib/oaiq";

declare global {
  interface Window {
    // Atribuído no index.html dentro do guard de navegador automatizado.
    gtag?: (...args: unknown[]) => void;
  }
}

export const GA_MEASUREMENT_ID = "G-PKDHYWCB40";

// Safe gtag wrapper — won't throw if blocked by adblocker
export const gtag = (...args: unknown[]) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag(...args);
    }
  } catch {
    // silently ignore if gtag is blocked
  }
};

export const trackEvent = (eventName: string, params?: Record<string, unknown>) => {
  gtag("event", eventName, params);
};

/**
 * Os três caminhos de contato alimentam o OpenAI Ads, não só o formulário.
 *
 * O evento do GA4 continua distinto em cada um — whatsapp_click,
 * phone_call_click e generate_lead — porque lá o esquema é nosso e dá para
 * separar. O pixel do OpenAI recebe lead_created nos três, deduplicado por
 * sessão dentro de trackOpenAILead.
 */
export const trackWhatsAppClick = () => {
  trackEvent("whatsapp_click", { method: "whatsapp", event_category: "engagement" });
  trackOpenAILead("whatsapp");
};

export const trackPhoneClick = () => {
  trackEvent("phone_call_click", { method: "phone", event_category: "engagement" });
  trackOpenAILead("phone");
};

export const trackFormSubmission = (formName: string) => {
  trackEvent("generate_lead", { form_name: formName, event_category: "conversion" });
  trackOpenAILead("form");
};
